import * as React from "react";
const SvgFiRrPrescription = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m17.87 18 2.963-4.445a1.001 1.001 0 0 0-1.664-1.11l-2.5 3.752-2.964-4.444A6.01 6.01 0 0 0 18.001 6c0-3.309-2.69-6-6-6H7.997a5.006 5.006 0 0 0-5 5v15a1 1 0 1 0 2 0v-8h6.468l4 6-2.963 4.445a1.001 1.001 0 0 0 1.664 1.11l2.501-3.752 2.501 3.752a1 1 0 1 0 1.664-1.11zM4.995 5c0-1.654 1.346-3 3-3H12c2.206 0 4 1.794 4 4s-1.794 4-4 4H4.996z"
    />
  </svg>
);
export default SvgFiRrPrescription;
